import { render, staticRenderFns } from "./UnsubscribeThanks.vue?vue&type=template&id=3d848077&"
import script from "./UnsubscribeThanks.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports